export default __webpack_public_path__ + "static/media/work-3right-1.48869b5d.png";